import * as React from "react";
import {isEmpty as _isEmpty} from "lodash"
import { UserGoalView, Goal } from "@curefit/gmf-common";
import TemplatedList from "../../TemplatedList";
import ModelFactory from "../../../models/ModelFactory";
import IMetric from "../../../models/metrics/IMetric";
import {EpochConstants} from "../../../utils/AppUtils";

interface HealthTargetsEditProps {
    goalsType?: string;
    staticGoals: Goal[];
    staticMetrics: IMetric[];
    updatedGoals: { item: UserGoalView }[];
    updateGoals: (goals: { item: UserGoalView }[]) => void;
    savedGoals: { item: UserGoalView }[];
    updateSavedGoals: (goals: { item: UserGoalView }[]) => void;
    deleteGoal?: (goal: UserGoalView) => any,
    isOnlyEdit?: boolean;
}
export default class OtherHealthTargetsEdit extends React.Component<HealthTargetsEditProps> {
    constructor(props: HealthTargetsEditProps) {
        super(props);
    }
    onGoalRemove = (index: number) => {
        let currUpdatedGoals = Object.assign([], this.props.updatedGoals);
        currUpdatedGoals.splice(index, 1);
        this.props.updateGoals(currUpdatedGoals);
    }

    onGoalChange = (updatedLifestyleGoal: { item: UserGoalView }, index: number) => {
        let currUpdatedGoals = Object.assign([], this.props.updatedGoals);
        currUpdatedGoals[index] = updatedLifestyleGoal;
        this.props.updateGoals(currUpdatedGoals);
    }

    onSavedGoalRemove = (index: number) => {
        let currUpdatedGoals = Object.assign([], this.props.savedGoals);
        let updatedGoal = currUpdatedGoals[index];
        if (!_isEmpty(updatedGoal.item.editInfo)) updatedGoal.item.editInfo.nextStatus = "CANCELLED";
        else updatedGoal.item.editInfo = { nextStatus: "CANCELLED" };
        this.props.deleteGoal(updatedGoal.item).then(() => {
            currUpdatedGoals[index] = updatedGoal;
            this.props.updateSavedGoals(currUpdatedGoals);
        });
    }
    render() {
        let startDate = new Date().getTime();
        let endDate = startDate + (EpochConstants.EPOCH_IN_AN_DAY * 30 * 12);
        return <div className={"other-health-target-editor-container"}>
            {
                !_isEmpty(this.props.savedGoals) &&
                <TemplatedList templateName={"otherGoal"} commonProps={{goalsType: this.props.goalsType, staticGoals: this.props.staticGoals, staticMetrics: this.props.staticMetrics}}
                               defaultItem={{item: ModelFactory.createNewLifestyleGoalWrapper(startDate, endDate)}}
                               listItems={this.props.savedGoals}
                               onItemRemove={this.onSavedGoalRemove}
                               autoAddNewRow={false} preventRowAddition={true}/>
            }
            <TemplatedList templateName={"otherGoal"} commonProps={{goalsType: this.props.goalsType, staticGoals: this.props.staticGoals, staticMetrics: this.props.staticMetrics}}
                           defaultItem={{item: ModelFactory.createNewLifestyleGoalWrapper(startDate, endDate)}}
                           listItems={this.props.updatedGoals}
                           onItemRemove={this.onGoalRemove}
                           onItemChange={this.onGoalChange}
                           preventRowAddition={this.props.isOnlyEdit}
                           autoAddNewRow={false} addRowText={"+ Add a goal"}/>
        </div>
    }
}